export { default as Img200 } from './processed/200/Bulletproof-S1.jpg';
export { default as Img400 } from './processed/400/Bulletproof-S1.jpg';
export { default as Imgthumb } from './processed/thumb/Bulletproof-S1.jpg';
export { default as ImgthumbBlurSmall } from './processed/thumbBlurSmall/Bulletproof-S1.jpg';
export { default as ImgthumbBlurLarge } from './processed/thumbBlurLarge/Bulletproof-S1.jpg';
export const ImgData = { width: 1240, height: 720, ratio: 0.5806451612903226, orientation: 'landscape' };
export const colors = {
  "Vibrant": {
    "_rgb": [
      75,
      122,
      170
    ],
    "_population": 493,
    "_hsl": [
      0.5842105263157894,
      0.3877551020408163,
      0.48039215686274506
    ]
  },
  "DarkVibrant": {
    "_rgb": [
      31,
      40,
      65
    ],
    "_population": 2218,
    "_hsl": [
      0.6225490196078431,
      0.3541666666666666,
      0.18823529411764706
    ]
  },
  "Muted": {
    "_rgb": [
      135,
      113,
      110
    ],
    "_population": 2356,
    "_hsl": [
      0.01999999999999993,
      0.10204081632653059,
      0.4803921568627451
    ]
  },
  "LightMuted": {
    "_rgb": [
      195,
      163,
      154
    ],
    "_population": 316,
    "_hsl": [
      0.03658536585365853,
      0.2546583850931676,
      0.6843137254901961
    ]
  },
  "DarkMuted": {
    "_rgb": [
      61,
      79,
      109
    ],
    "_population": 2227,
    "_hsl": [
      0.6041666666666666,
      0.2823529411764706,
      0.3333333333333333
    ]
  }
}


// WEBPACK FOOTER //
// ./src/content/images/Bulletproof-S1.js